// Question Types
// 1. MCQs | Multiple Choice | single
// 2. boolean | true/false | single
// 3. MAQs | Multiple Answers | multiple

import { Topic } from '.'

export const inteligenciaEmocional: Topic = {
  topic: 'InteligenciaEmocional',
  level: 'Intermediate',
  totalQuestions: 10,
  totalScore: 95,
  totalTime: 600,
  questions: [
    {
      question: 'Com que frequência consegue reconhecer as emoções que está sentindo?',
      choices: [
        { choice: "Quase nunca", score: 1 },
        { choice: "Poucas vezes", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Bastantes vezes", score: 4 },
        { choice: "Muitas vezes", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência perde a calma quando se sente frustrado?',
      choices: [
        { choice: "Quase nunca", score: 1 },
        { choice: "Poucas vezes", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Bastantes vezes", score: 4 },
        { choice: "Muitas vezes", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência as pessoas dizem que você é um bom ouvinte?',
      choices: [
        { choice: "Quase nunca", score: 1 },
        { choice: "Poucas vezes", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Bastantes vezes", score: 4 },
        { choice: "Muitas vezes", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência consegue acalmar-se quando se sente ansioso ou perturbado?',
      choices: [
        { choice: "Quase nunca", score: 1 },
        { choice: "Poucas vezes", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Bastantes vezes", score: 4 },
        { choice: "Muitas vezes", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência gosta de organizar grupos de pessoas?',
      choices: [
        { choice: "Quase nunca", score: 1 },
        { choice: "Poucas vezes", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Bastantes vezes", score: 4 },
        { choice: "Muitas vezes", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência sente dificuldade em manter o foco em objetivos de longo prazo?',
      choices: [
        { choice: "Quase nunca", score: 1 },
        { choice: "Poucas vezes", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Bastantes vezes", score: 4 },
        { choice: "Muitas vezes", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência sente dificuldade em avançar quando se sente frustrado ou infeliz?',
      choices: [
        { choice: "Quase nunca", score: 1 },
        { choice: "Poucas vezes", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Bastantes vezes", score: 4 },
        { choice: "Muitas vezes", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência conhece seus pontos fortes e fracos?',
      choices: [
        { choice: "Quase nunca", score: 1 },
        { choice: "Poucas vezes", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Bastantes vezes", score: 4 },
        { choice: "Muitas vezes", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência evita conflitos e negociações?',
      choices: [
        { choice: "Quase nunca", score: 1 },
        { choice: "Poucas vezes", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Bastantes vezes", score: 4 },
        { choice: "Muitas vezes", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência não se sente satisfeito com seu trabalho?',
      choices: [
        { choice: "Quase nunca", score: 1 },
        { choice: "Poucas vezes", score: 2 },
        { choice: "Às vezes", score: 3 },
        { choice: "Bastantes vezes", score: 4 },
        { choice: "Muitas vezes", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    

  ],
}
